import React from 'react';
import { useWishlist } from '../../hooks/useWishlist';
import { WishlistContext } from './WishlistContext';

export const WishlistProvider = ({ children }) => (
  <WishlistContext.Provider value={useWishlist()}>
    {children}
  </WishlistContext.Provider>
);
